export const submissionsStoreKey = 'submissions';
